import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getConsequenceFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`consequences.fields.Title`),
      columnHeader: t(`consequences.columns.title`),
      allowAsConditionSource: true,
    },
    Type: {
      fieldId: 'Type',
      formLabel: t(`consequences.fields.Type`),
      columnHeader: t(`consequences.columns.type`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'consequences.types',
      },
    },
    Criticality: {
      fieldId: 'Criticality',
      formLabel: t(`consequences.fields.Criticality`),
      columnHeader: t(`consequences.columns.criticality`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'criticality',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    CostType: {
      fieldId: 'CostType',
      formLabel: t(`consequences.fields.CostType`),
      columnHeader: t(`consequences.columns.costType`),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'consequences.costType',
      },
    },
    CostValue: {
      fieldId: 'CostValue',
      formLabel: t(`consequences.fields.CostValue`),
      columnHeader: t(`consequences.columns.costValue`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`consequences.fields.Description`),
      columnHeader: t(`consequences.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
  } as const satisfies FormConfig;
};
